import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
class TimeFormat extends React.Component {   

    constructor(props){
        super(props);
    }
    componentWillMount(){ }
    
    componentDidMount(){ }

    render(){
        if(!this.props.stamp) return null;
        let format;

        switch(this.props.type){
            case 'day':
                format = 'MMMM Do YYYY';
                break;

            case 'time':
                format = 'h:mm a';
                break;

            default:
                format = null;
                break;
        }

        return (
            <span className="TimeFormat">
                {moment(this.props.stamp).format(format)}
                <style jsx>{`
                    .TimeFormat {}
                `}</style>
            </span>
        )
    }
}

TimeFormat.propTypes = {
    
}

export default TimeFormat;


// WEBPACK FOOTER //
// ./src/components/common/TimeFormat.js